// HomePage.js
import React from 'react';
import Hero from '../components/Hero';
import StatsSection from '../components/StatsSection';
import ServicesSection from '../components/ServicesSection';
import ServiceCardsSection from '../components/ServiceCardsSection';
import ResourcesSection from '../components/ResourcesSection';
import NewsSection from '../components/NewsSection';
import BlogCardsSection from '../components/BlogCardsSection';
import HowItWorksComponent from '../components/HowItWorksComponent';
import AboutUs from '../components/AboutComponent';
import FAQs from '../components/FAQs';


const HomePage = () => {
  return (
    <div>
      <Hero />
      <StatsSection />
      <ServicesSection />
      <ServiceCardsSection />
      <ResourcesSection />
      <NewsSection />
      <BlogCardsSection />
      {/* <HowItWorksComponent /> */}
      {/* <AboutUs /> */}
      {/* <FAQs /> */}

      {/* More sections can be added here later */}
    </div>
  );
};

export default HomePage;
